import React, { useState, useRef, useEffect } from "react";
import "./index.css";
import infoIcon from "../../../../../assets/design-revamp-company/company-detail-headers/company-total-info-icon.svg";

// Custom hook to handle clicks outside of the tooltip
const useOutsideClick = (callback) => {
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback]);

  return ref;
};

const InfoIcon = ({ text }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const tooltipRef = useOutsideClick(() => setIsTooltipVisible(false));

  return (
    <div className="info-icon-container" ref={tooltipRef}>
      <img
        src={infoIcon}
        alt="Info Icon"
        className="info-icon"
        onClick={() => setIsTooltipVisible(!isTooltipVisible)}
      />

      {isTooltipVisible && <div className="info-tooltip">{text}</div>}
    </div>
  );
};

export default InfoIcon;
